import "@common/jquery.ext";
import {ajax} from "@common/ajax";
import {menu} from "@common/menu";
import {alert} from "@common/message";

$(() => {
    $("#mbrId").enter("#email");
    $("#email").enter(doFindPw);
    $("#btnSubmit").click(doFindPw);
    $("#btnCancel").click(menu.goLogin);
});

const doFindPw = (): void => {
    // hide message
    hideMessage();

    // check valid
    if ($("#mbrId").trim().val() === "") {
        showMessage("아이디를 입력해 주세요.");
        $("#mbrId").focus();
    }
    else if ($("#email").trim().val() === "") {
        showMessage("이메일을 입력해 주세요.");
        $("#email").focus();
    }
    else {
        ajax.formSubmit({
            url: "./findPwProc.do",
            form: "#frmFindPw",
            func: {
                success: (result: any) => {
                    alert("임시 비밀번호가 이메일로 발송되었습니다.", menu.goLogin);
                },
                error: (result: any) => {
                    let message = ajax.getErrorMessage(result, [
                        { code: 1, message: "회원 정보를 찾을 수 없습니다." }
                    ]);
                    showMessage(message);
                }
            }
        });
    }
}

const showMessage = (message: string): void => {
    $(".account-message").html(message).show();
}

const hideMessage = (): void => {
    $(".account-message").html("");
}
